/**
 * Created by mrocha.
 */
// ReportsView.js

import 'bootstrap-treeview/src/js/bootstrap-treeview.js';

import RestService      from 'RestService';
import eventBus         from 'EventBus.js';
import $                from 'jquery';
import {View}           from 'backbone';
import constants        from 'Constants.js';
import util             from 'util/Util';

//======================================================================================
// Presents a clickable drill-down tree view. No HTML template used.
// -Rene Lopez, 2016-04-18
//======================================================================================

class ReportsView extends View {

    initialize(opts) {
        this.options = opts || {};
        this.STATIC_TREEVIEW_OPTIONS = ['Private Reports', 'Shared Reports'];

        this.checkForInstances= opts.checkForInstances!==undefined ? opts.checkForInstances : true;
        this.publishedInstances= opts.publishedInstances!==undefined ? opts.publishedInstances : false;

        // PF-1857 Adding extra condition for selecting a form with instances.
        this.selectableFormWithInstances= opts.selectableFormWithInstances!==undefined ? opts.selectableFormWithInstances : false;

        this.tree = [
            {
                text: "Private Reports",
                icon: constants.DB_ICON_EMPTY,
                borderColor: constants.DB_BORDER_COLOR,
                color: constants.DB_FG_DIM,
                backColor: constants.DB_BACK_COLOR,
                selectable: true,
                state: {checked: true, disabled: false, expanded: false, selected: false},
                tags: ['attn'],
                nodes: [{}]  // Adding empty array subnodes so the UI can render them and new ones can be added.
            },
            {
                text: "Shared Reports",
                icon: constants.DB_ICON_EMPTY,
                borderColor: constants.DB_BORDER_COLOR,
                color: constants.DB_FG_DIM,
                backColor: constants.DB_BACK_COLOR,
                selectable: true,
                state: {checked: true, disabled: false, expanded: false, selected: false},
                tags: ['attn'],
                nodes: [{}]  // Adding empty array subnodes so the UI can render them and new ones can be added.
            }
        ];

        this.listenTo(this.model, 'change', this.render);

        return this;
    }

    //=================================================================
    // Adds Folders and Items to the in-memory model so they can be properly rendered into the
    // TreeView Widget.
    //=================================================================
    addItemsAndFoldersToReportTreeModel(currentNode,forms,groupType){
        currentNode.nodes=[];
        if(!forms){
            currentNode.nodes.push(this.createReportNode({
                text: 'No Items'
            }));
            return;
        }
        if(forms.Group) {

            // Checking whether is an Array or an object so we can loop the items
            // or access the single object properties
            if (forms.Group instanceof Array) {

                for (let group of forms.Group) {
                    currentNode.nodes.push(this.createReportNode(
                        {
                            text: group['@name'],
                            GUID: group['@guid'],
                            icon: constants.DB_ICON_FOLDER,
                            nodes: [],
                            groupType: groupType || currentNode.groupType,
                            groupId: groupType !== constants.REPORTS_VIEW_GROUP_TYPE ? group['@id'] : group['@groupId']
                        }))
                }
            }
            else{
                currentNode.nodes.push(this.createReportNode(
                    {
                        text: forms.Group['@name'],
                        GUID: forms.Group['@guid'],
                        icon: constants.DB_ICON_FOLDER,
                        nodes: [],
                        groupType: groupType || currentNode.groupType,
                        groupId: groupType !== constants.REPORTS_VIEW_GROUP_TYPE ? forms.Group['@id'] : forms.Group['@groupId']
                    }))
            }
        }



        if(forms.Item) {
            let itemsArray = util.enforceArrayType(forms.Item);
            for (let form of itemsArray) {
                currentNode.nodes.push(this.createReportNode({
                    text: form['@name'],
                    id: form['@id'],
                    GUID: form['@guid'],
                    linkId: form['@linkId']
                }));
            }
        }
    }

    // =====================================================================================================
    // Creates a node by passing custom properties that will be overwritten by the default ones if needed.
    // =====================================================================================================
    createReportNode(properties = {}) {
        let defaults = {
            text: '',
            id: '',
            icon: constants.DB_ICON_EMPTY,
            borderColor: constants.DB_BORDER_COLOR,
            color: constants.DB_FG_DIM,
            backColor: constants.DB_BACK_COLOR,
            selectable: true,
            tags: ['attn']
        };
        return Object.assign({}, defaults, properties);
    }

    // ========================================================================
    // Performs a deep search of the current node being clicked in the treeview model so it can be updated
    // and render a new one once again.
    // ========================================================================
    _getObjectReportByGroupId(tree,groupId) {
        var result = null;
        if (tree instanceof Array) {
            for (var i = 0; i < tree.length; i++) {
                result = this._getObjectReportByGroupId(tree[i],groupId);
                if (result) {
                    break;
                }
            }
        }
        else {
            for (var prop in tree) {
                if (prop === 'groupId') {
                    if (tree[prop] === groupId) {
                        return tree;
                    }
                }
                
                if (/*tree[prop] instanceof Object || */prop === 'nodes' && tree[prop] instanceof Array) {
                    result = this._getObjectReportByGroupId(tree[prop],groupId);
                    if (result) {
                        break;
                    }
                }
            }
        }
        return result;
    }



    //=======================================================================
    // Dispatch correct model update on each node collapsed in the Tree View.
    //=======================================================================
    __onReportNodeCollapsed(evt, node) {
        if (this.STATIC_TREEVIEW_OPTIONS.indexOf(node.text) !== -1) {
            this._processCollapseForStaticNodes(node);
        } else {
            this._processCollapseForDynamicNodes(node);
        }
    }

    //=======================================================================
    // Dispatch correct model update on each node expanded in the Tree View.
    //=======================================================================
    _onReportNodeExpanded(evt, node) {
        if (this.STATIC_TREEVIEW_OPTIONS.indexOf(node.text) !== -1) {
            this.__processExpansionForStaticReportNodes(node);
        } else {
            this._processExpansionForDynamicReportNodes(node);
        }
    }

    //==================================================================
    // Dispatch correct detail subview according to selected
    // tree node.
    //==================================================================
    _onReportSelected(evt, node) {
        const formIcon = constants.DB_ICON_EMPTY;
        if(!this.options.checkForInstances && node.icon === formIcon){
            eventBus.trigger('ReportSelected', node.id, node.text, node.GUID, node.linkId);
        }

        // PF-1857 Perfoming the validation for selecting a folder that has instances.
        else if(this.options.selectableFormWithInstances){
            eventBus.trigger('ReportSelected', node.id, node.text, node.GUID, node.linkId);
        }
        else if (node.nodes) {
            $('button.btn-select-field').button("disable");
        }
        else {
            eventBus.trigger('ReportSelected', node.id, node.text, node.GUID, node.linkId);
        }
    }

    // ==============================================================
    // Updates the status of the expansion of the node being clicked
    // if it is one that was retrieved from the API.
    // ==============================================================
    _processCollapseForDynamicNodes(node) {
        let modelNode=this._getObjectReportByGroupId(this.tree,node.groupId);
        modelNode.state = {expanded : false};
    }

    // ==============================================================
    // Updates the status of the expansion of the node being clicked
    // if it is one that is between the four expected groups(Edit,View,Private).
    // ==============================================================
    _processCollapseForStaticNodes(node) {
        switch (node.text) {
            case 'Edit Reports':
                this.tree[0].state.expanded = false;
                break;
            case 'View Reports':
                this.tree[1].state.expanded = false;
                break;
            case 'Private Reports':
                this.tree[0].nodes[0].state = {expanded: false};
                break;
        }
    }

    // ======================================================================================================
    // Retrieves the child nodes of an specific group if the group was clicked, and also updates the current
    // model so the treeview can render these retrieved child nodes as well.
    // ======================================================================================================
    _processExpansionForDynamicReportNodes(node) {
        let modelNode=this._getObjectReportByGroupId(this.tree,node.groupId);
        if (modelNode.groupType === constants.REPORTS_VIEW_GROUP_TYPE) {
            RestService.getViewReports(modelNode.groupId).then((data) => {
                let forms = data.RESULT.RESPONSE.Group;
                this.addItemsAndFoldersToReportTreeModel(modelNode, forms);

                // Modifying the state to be expanded now both on the parent and children.
                modelNode.state = {expanded: true};
                this.render();

            }).catch((error) => {
                console.log(error);
            });
        }
        else{
            RestService.getReportsByGroupType(modelNode.groupType,modelNode.groupId).then((data) => {
                let forms = data.RESULT.RESPONSE.Group;
                this.addItemsAndFoldersToReportTreeModel(modelNode, forms);

                // Modifying the state to be expanded now both on the parent and children.
                modelNode.state = {expanded: true};
                this.render();

            }).catch((error) => {
                console.log(error);
            });
        }
    }

    // ======================================================================================================
    // Method that calls an specific functionality for each one of the expected groups at start.
    // ======================================================================================================
    __processExpansionForStaticReportNodes(node) {
        switch (node.text) {
            case 'Private Reports':
                this._processPrivateReports();
                break;
            case 'Shared Reports':
                this._processSharedReports();
                break;
        }
    }

    _processPrivateReports() {
        let self = this;
        if ( !this.options.publishedInstances ) {
            RestService.getReportsByGroupType(constants.REPORTS_PRIVATE_GROUP_TYPE).then((data) => {
                let privateForms = data.RESULT.RESPONSE.Group;
                this.addItemsAndFoldersToReportTreeModel(self.tree[0], privateForms, constants.REPORTS_PRIVATE_GROUP_TYPE);

                // Modifying the state to be expanded now both on the parent and children.
                self.tree[0].state.expanded = true;
                this.render();

            }).catch((error) => {
                console.log(error);
            });
        }else{
            RestService.getBrowseFormsForReporting(constants.REPORTS_PRIVATE_GROUP_TYPE).then((data) => {
                let privateForms = data.RESULT.RESPONSE.Group;
                this.addItemsAndFoldersToReportTreeModel(self.tree[0], privateForms,constants.REPORTS_PRIVATE_GROUP_TYPE);
                // Modifying the state to be expanded now both on the parent and children.
                self.tree[0].state.expanded = true;
                this.render();

            }).catch((error) => {
                console.log(error);
            });
        }
    }

    _processSharedReports() {
        let self = this;
        if ( !this.options.publishedInstances ) {
            RestService.getReportsByGroupType(constants.REPORTS_SHARED_GROUP_TYPE).then((data) => {
                let sharedForms = data.RESULT.RESPONSE.Group;
                this.addItemsAndFoldersToReportTreeModel(self.tree[1], sharedForms, constants.REPORTS_SHARED_GROUP_TYPE);

                // Modifying the state to be expanded now both on the parent and children.
                self.tree[1].state.expanded = true;
                this.render();

            }).catch((error) => {
                console.log(error);
            });
        }
        else{
            RestService.getBrowseFormsForReporting(constants.REPORTS_SHARED_GROUP_TYPE).then((data) => {
                let sharedForms = data.RESULT.RESPONSE.Group;
                this.addItemsAndFoldersToReportTreeModel(self.tree[1], sharedForms,constants.REPORTS_SHARED_GROUP_TYPE);
                // Modifying the state to be expanded now both on the parent and children.
                self.tree[1].state.expanded = true;
                this.render();

            }).catch((error) => {
                console.log(error);
            });
        }
    }

    //==================================================================
    // Normal BB rendering from HTML template, plus start select
    // listener for tree.
    //==================================================================
    render() {
        let self = this;
        // Rendering the tree.
        $(self.options.el).treeview(
            {
                data: self.tree, levels: 1, onNodeSelected: self._onReportSelected.bind(this),
                // Binding the current scope to the Backbone model so the function assigned can see it and manipulate the render process.
                onNodeExpanded: self._onReportNodeExpanded.bind(this),
                onNodeCollapsed: self.__onReportNodeCollapsed.bind(this)
            }
        );

        this.delegateEvents();
        
        return this;
    }

}

export default ReportsView;
